import { combineEpics } from 'redux-observable';

import Api from 'lib/Api';
import ReduxHelper from 'lib/ReduxHelper';
import { REPORTS_ACTION_TYPES as AT } from './Reports.actions';

export default combineEpics(
  ...ReduxHelper.createDefaultEpics(
    [AT.REPORTS_FETCH_AUCTION_DATA, Api.fetchAuctionsReportData],
    [AT.REPORTS_FETCH_INSURANCE_GENERAL_DATA, Api.fetchReportData],
    [AT.REPORTS_FETCH_INSURANCE_FOLDER_DATA, Api.fetchReportData],
    [AT.REPORTS_FETCH_MERCHANT_GENERAL_DATA, Api.fetchReportData],
    [AT.REPORTS_FETCH_ADMIN_GENERAL_DATA, Api.fetchReportData],
    [AT.REPORTS_FETCH_ADMIN_FOLDER_DATA, Api.fetchReportData],
  ),
);
